import { useEffect, useState } from "react";
import { Pin } from "lucide-react";
import { api } from "@/lib/api";

// The papers this reader keeps and likes most — one tap to let them lead the feed.
export const PinSuggestions = ({ onPin, refreshKey = 0 }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/news/pins/suggested")
      .then(({ data }) => setRows(data.suggested))
      .catch(() => {});
  }, [refreshKey]);

  if (rows.length === 0) return null;

  return (
    <div className="mt-3 flex flex-wrap items-center gap-2" data-testid="pin-suggestions">
      <span className="text-[11px] uppercase tracking-widest text-ink-soft">
        You read these most
      </span>
      {rows.map((row) => (
        <button
          key={row.source}
          data-testid={`suggest-pin-${row.source}`}
          onClick={() => onPin(row.source, true)}
          title={`${row.kept} saved · ${row.liked} liked`}
          className="inline-flex min-h-[30px] items-center gap-1.5 rounded-full border border-white/10 px-3 text-xs text-ink-soft transition-colors hover:border-brand/50 hover:text-brand"
        >
          <Pin className="h-3 w-3 text-brand" /> Let {row.source} lead
        </button>
      ))}
    </div>
  );
};
